"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createSafeStringifyReplacer = function () {
    var seen = new WeakSet();
    var replacer = function (_key, value) {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return '[Circular]';
            }
            seen.add(value);
        }
        return value;
    };
    return replacer;
};
var safeStringify = function (value, space) {
    try {
        return JSON.stringify(value, createSafeStringifyReplacer(), space);
    }
    catch (e) {
        return undefined;
    }
};
exports.default = safeStringify;
